import Vue from 'vue'
import App from 'RuterTheme/App.vue'
import router from 'RuterTheme/router'
import store from 'RuterTheme/store'
import axios from 'axios'
import Vuex from 'vuex'
import VueGtm from 'vue-gtm'
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin'
import filters from 'RuterShared/filters'
import i18n from 'RuterShared/i18n'
import OverlayPlugin from 'RuterShared/plugins/Overlay'
import ScrollToPlugin from '../node_modules/dc-vue-default/src/plugins/ScrollTo';
import HandleLinkClickPlugin from '../node_modules/dc-vue-default/src/plugins/HandleLinkClick';
import InternalUrlHelperPlugin from '../node_modules/dc-vue-default/src/plugins/InternalUrlHelperPlugin';
//import ResponsiveImageUrlPlugin from "../node_modules/dc-vue-default/src/plugins/ResponsiveImageUrlPlugin";

document.body.classList.remove('no-js');

Vue.config.productionTip = false

Vue.use(Vuex)

Vue.use(VueGtm, {
	id: 'GTM-PVZFXFM',
});

Vue.use(VueCookieBot, {
	blockingMode: 'auto',
	cookieBotID: '8159a860-f472-4053-bc7f-788ff4ad48fe',
	defaultLocale: 'no'
})

Vue.prototype.$http = axios
if (window.dcSite.nonce) {
  Vue.prototype.$http.defaults.headers.common['X-WP-Nonce'] = window.dcSite.nonce
}
Vue.use(filters)
Vue.use(OverlayPlugin)
Vue.use(ScrollToPlugin)
Vue.use(HandleLinkClickPlugin)
Vue.use(InternalUrlHelperPlugin)
//Vue.use(ResponsiveImageUrlPlugin)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
